<template>
  <div class="container">
    <h1
      class="mt-5 mb-5 center color-primary"
      style="font-family: Comfortaa-Bold"
    >
      Jovool
    </h1>
    <h2>Recuperar senha</h2>
    <div class="card mb-4">
      <div class="card-body">
        <label for="password">Digite seu email</label>
        <input
          class="form-control"
          type="email"
          v-model="candidates.email"
          placeholder="Email"
        />

        <div class="actions">
          <button
            type="button"
            @click="newPassoword"
            class="mt-3 btn btn-success"
          >
            {{ !load ? "Recuperar minha senha" : "" }}
            <div v-show="load" class="spinner-border text-light" role="status">
              <span class="sr-only"></span>
            </div>
          </button>
        </div>

        <div v-if="success" class="alert mt-2 alert-success">
          <span
            >Processo encaminhado com sucesso, confirá o seu email com os passos
            para redefinir sua senha</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { required, email } from "vuelidate/lib/validators";

export default {
  data: () => ({
    success: false,
    load: false,
    candidates: {
      email: "",
    },
  }),
  methods: {
    newPassoword() {
      this.load = true;
      this.$v.candidates.$touch();
      console.log(this.candidates.email);
      console.log(this.$v.candidates);
      if (!this.$v.candidates.error) {
        axios
          .post("/candidates/password.json", { candidate: this.candidates })
          .then((response) => {
            console.log(response);
            this.load = false;
            this.success = true;
          });
        return;
      } else {
        this.$toast.error("Preencha seu email");
        this.load = false;
      }
    },
  },
  validations: {
    candidates: {
      email: { required, email },
    },
  },
};
</script>
